export default "__VITE_ASSET__f3YZWRZo__"